module.exports = __webpack_public_path__ + "img/concluido.2d6a696d.svg";